export const take = <T>(array: Array<T>, n = 0): T[] => {
  if (!(array != null && array.length)) {
    return [];
  }
  return array.slice(0, n < 0 ? 0 : n);
};

export const compact = <T>(array: Array<T | null | undefined | false | '' | 0> | null | undefined):T[] => {
  const result: T[] = [];

  if (array == null) {
    return result;
  }

  array.forEach((value) => {
    if (value) {
      result.push(value);
    }
  });

  return result;
};

export const times = <TResult>(n: number, iteratee: (num: number) => TResult): TResult[] => Array.from(Array(n)).map((v, index) => iteratee(index));

export const sortBy = <T extends Record<string, unknown>>(array: Array<T>, field: string): T[] => array.sort((a, b) => {
  if ((a[field] as number) < (b[field] as number)) {
    return -1;
  }
  if ((a[field] as number) > (b[field] as number)) {
    return 1;
  }
  // a must be equal to b
  return 0;
});
